import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomLoading from "../../../../GeneralComponents/CustomLoading/customloading";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import "./passangerdata.css";
import NotificationPass from "./subComponents/Notifications/notification";
import RoomPassInfo from "./subComponents/RoomPassInfo/roompassinfo";
import { convertPrice } from "../../../../../services/currencyService";
import {
  bookHotel,
  cancellationPolicies,
  newHotelOrder,
} from "../../../../../services/fhpService";
import CustomAlertAgent from "../../../../GeneralComponents/CustomAlertAgent/customalertagent";
import {
  DYNAMIC_PACKAGES,
  useSearch,
} from "../../../../../contexts/SearchContext";
import { Loader } from "../../../../Loader/Loader";
import { useOrder } from "../../../../../contexts/OrderContext";
import { useAppContext } from "../../../../../contexts/AppContext";
import { Button, Card, Input, message, notification } from "antd";
import FlightSelection from "../../../../FlightSelection/Index";
import Supplement from "../../../../InfoBox/Supplement";
import { useSelectedResult } from "../../../../../contexts/SelectedResultContext";
import PassengerData from "../../../../PassengersData/PassengerData";
import { getUserDetails } from "../../../../../services/authService";
import {
  get_depret_from_result,
  parseToLdsDate,
} from "../../../../../utils/LDSHelpers";
import { ApiReqBaseUrl, BaseUrl } from "../../../../../assets/GlobalVariables";
import { TermsAndConditions } from "../../../../../Pages/AgentTerms/AgentTerms";
import { saveDynamicPackage } from "../../../../../services/dynamicService";

export const errorCodes = {
  E10000:
    "קלט משתמש לא חוקי: שגיאה בפרטי התאריכים – תאריך צ’ק-אין לא יכול להיות בעבר; תאריך צ’ק-אאוט חייב להיות אחרי הצ’ק-אין; הפרמטר Nights הוסבר כמת בטל ובמידה וסופק, חייב להתאים למספר לילות בין צ’ק-אין לצ’ק-אאוט.",
  E10001:
    "קלט משתמש לא חוקי: שגיאה בפרטי החדרים – לא ניתן להשאיר חדר ריק; מספר החדרים חייב להיות בין 1 ל-4; בכל חדר חייב להיות לפחות מבוגר אחד; מספר המבוגרים בחדר לא יעלה על 8; סכום המבוגרים הכולל>0; גילאי ילדים חייבים להיות בין 0 ל-17.",
  E10002:
    "קלט משתמש לא חוקי: שגיאה בפרטי היעד – RadiusInMeters, אם מצוין, חייב להיות >0; Latitude בין -90 ל-90; Longitude בין -180 ל-180; לא ניתן לציין RadiusInMeters עם HotelIds או SupplierLocationIds; GeoLocationInfo לא יכול להיות עם HotelIds; אם צוינה GeoLocationInfo, חייב להיות RadiusInMeters; יש לכלול לפחות HotelLocation, HotelIds, SupplierLocationIds או GeoLocation; מספר פריטים ב-HotelIds חייב להיות מתחת למקסימום; RadiusInMeters חייב להיות ≤ { }; הערך המצוי של HotelLocation לא נמצא.",
  E10003:
    "קלט משתמש לא חוקי: שגיאה כללית – חייבים ציון תקין של DesiredResultCurrency ותושבות; DetailLevel=Default מותר רק עם חיפוש לפי מזהה מלון יחיד; Response Language שגוי (נתמך רק 'EN'); DetailLevel ערך לא נתמך.",
  E10199: "שגיאת קונפיגורציה כללית.",
  E10200: "לא נמצאו תוצאות.",
  E10201: "שגיאה בתקשורת עם הספק.",
  E10202: "שגיאת אישורים.",
  E10203: "גישה אסורה.",
  E10204: "IP לא מורשה.",
  E10205: "שגיאה בגישה למלאי.",
  E10206: "הגעת למגבלת בקשות – גבול QPS מול הספק הושג.",
  E10207: "שגיאה בתאריך הצ’ק-אין.",
  E10208: "שגיאה בשוק המקור.",
  E10209: "שגיאה במזהה המלון.",
  E10210: "שגיאה בתאריך הצ’ק-אאוט.",
  E10211: "שגיאת זמן חיפוש.",
  E10212: "שגיאה במיקום.",
  E10213: "שגיאת Pax.",
  E10214: "שגיאת תפוסה (Occupancy).",
  E10297: "שגיאה כללית בבקשה.",
  E10298: "שגיאה פנימית.",
  E10300: "הספק לא שימש כמתווך – Supplier Name: {0}, Contract Id: {1}.",
  E10301: "לא נמצאו מזהי מלונות מתאימים. Supplier Name: {0}.",
  E10302: "לא נמצאו מיקומים מתאימים. Supplier Name: {0}, Location Id: {1}.",
  E10303: "שגיאה בפיענוח נתוני ספק. Supplier Name: {0}, Contract Id: {1}.",
  E10304: "שגיאת Timeout מהספק. Supplier Name: {0}, Contract Id: {1}.",
  E10305: "קריטריון חיפוש לא נתמך. Supplier Name: {0}.",
  E10306: "קונפיגורציה שגויה במערכת הספק. Supplier Name: {0}.",
  E10307: "חיפוש לפי {0} לא נתמך על ידי הספק. Supplier Name: {1}.",
  E10308: "לא הוגדר סוג חיפוש לספק. Supplier Name: {0}.",
  E10398: "שגיאת חיפוש בלתי צפויה.",
  E10399: "שגיאה כללית בחיפוש.",
  E20000: "קלט משתמש לא חוקי: פרטי לקוח שגויים.",
  E20001: "קלט משתמש לא חוקי: פרטי כרטיס אשראי שגויים.",
  E20099: "קלט משתמש לא חוקי: שגיאה כללית בקלט.",
  E3000: "תשלום לא מאושר.",
  E20225: "לא ניתן לאשר הזמנה עקב CVV שגוי.",
  E20221: "לא ניתן לאשר הזמנה עקב מחיר שגוי שנשלח.",
  E20100: "קונפיגורציה: אין הרשאה להזמין מחירים נטו לא ניתנים לביטול.",
  E20101: "אין מספיק obligo להזמנה (הנוכחי: {X}, נדרש: {X}).",
  E20102: "מחיר ההזמנה מחוץ לטווח.",
  E20103: "ההזמנה לא מורשית לחשבון זה.",
  E20104: "הזמנה מבוטלת עבור cluster '{X}'.",
  E20105: "הזמנה מבוטלת עבור סוג שירות '{X}'.",
  E20106: "הזמנה מבוטלת עבור flow '{X}'.",
  E20107: "המשתמש '{0}' לא מורשה לבצע '{1}'.",
  E20108:
    "'ChargeAmount' '{0}' לא תקין (חייב להיות >0 ולכל היותר מחיר ההזמנה).",
  E20109: "לא ניתן לחייב service-fee.",
  E20110: "שיטת תשלום לא זמינה.",
  E20111: "ערך ההנחה לא תקין.",
  E20199: "שגיאת קונפיגורציה כללית בהזמנה.",
  E11001:
    "GetPackages לא מותר עם DetailLevel: 'Low'. יש לבצע חיפוש חדש עם אחת האפשרויות: Meta, MetaExtended, MetaNoTax, MetaAdvanced, NoPackages, NoPackagesNoTax.",
  E20300: "הזמנה לא מאושרת עקב שינוי במחיר.",
  E20301: "הזמנה לא מאושרת עקב שינוי מטבע המחיר.",
  E20302: "הזמנה לא מאושרת עקב שינוי במדיניות הביטול.",
  E20303: "הזמנה לא מאושרת עקב שינוי בריבית מדיניות הביטול.",
  E20304: "הזמנה לא מאושרת – אין זמינות בספק.",
  E20305: "התשובה מה-prebook לא התקבלה.",
  E20306: "הגיע Timeout (3 דקות) – ייתכן שההזמנה הושלמה אצל הספק.",
  E20307: "אין להזמין שוב פריט שכבר הוזמן באותה session.",
  E20308: "חיוב service-fee לא מורשה בחשבון 3D.",
  E20395: "לא התקבלה תגובת הזמנה מהספק.",
  E20396: "תקלה בתשובת הזמנה – מבנה לא ידוע.",
  E20397: "שגיאה לא מטופלת בתשובת הזמנה מהספק.",
  E20398: "שגיאת הזמנה פנימית.",
  E20200: "הזמנה לא מאושרת עקב שינוי מחיר.",
  E20201: "הזמנה לא מאושרת עקב שינוי מטבע.",
  E20202: "הזמנה לא מאושרת עקב שינוי מדיניות ביטול.",
  E20203: "הזמנה לא מאושרת עקב שינוי דמי ביטול.",
  E20204: "הזמנה לא מאושרת עקב שינוי מטבע דמי ביטול.",
  E20205: "הזמנה לא מאושרת עקב שינוי תאריכי ביטול.",
  E20206: "הזמנה לא מאושרת עקב תפוגת tariff.",
  E20207: "הזמנה לא מאושרת עקב חוסר זמינות.",
  E20208: "הזמנה לא מאושר – תקלה מספק צד שלישי.",
  E20209: "הזמנה לא מאושרת – בעיות תקשורת.",
  E20210: "הזמנה לא מאושרת – שגיאת שם נוסע.",
  E20211: "הזמנה לא מאושרת – שגיאת אימייל נוסע.",
  E20212: "הזמנה לא מאושרת – הזמנה כפולה.",
  E20213: "הזמנה לא מאושרת – בעיית קו אשראי.",
  E20214: "הזמנה לא מאושרת – בעיית הרשאה.",
  E20215: "הזמנה לא מאושרת – שגיאה כללית באישור כרטיס.",
  E20216: "הזמנה לא מאושרת – שגיאה באישור כרטיס.",
  E20217: "הזמנה לא מאושרת – פרטי כרטיס שגויים.",
  E20218: "הזמנה לא מאושרת – סוג כרטיס לא נתמך.",
  E20219: "הזמנה לא מאושרת – הגבלה לפי לאום.",
  E20220: "הזמנה לא מאושרת – סטטוס הזמנה נדחה.",
  E20297: "הזמנה לא מאושרת – שגיאה כללית בבקשה.",
  E20298: "הזמנה לא מאושרת – שגיאה כללית.",
  E20299: "שגיאה לא מטופלת מספק.",
  I0200: "מידע: פעולה הושלמה בהצלחה.",
  I0404: "מידע: לא נמצאו תוצאות. Supplier Name: {0}, Contract Id: {1}.",
  I0405: "מידע: בקשה לא נתמכת. Supplier Name: {0}, Contract Id: {1}.",
  I0406: "מידע: פרטי אשראי נשלחו ללא צורך – יתעלם מהם.",
  I0600: "מידע: שם נוסע כפול – ינסה לתקן ולשחזר.",
  I0601: "מידע: תקלה בתקשורת ספק. Supplier Name: {0}, Contract Id: {1}.",
  W4306: "אזהרה: שגיאת פענוח נתוני ספק. Supplier Name: {0}, Contract Id: {1}.",
  W4307: "אזהרה: Timeout מהספק. Supplier Name: {0}, Contract Id: {1}.",
  W4308: "אזהרה: קריטריון חיפוש לא נתמך. Supplier Name: {0}.",
  W4309: "אזהרה: קונפיגורציה שגויה במערכת הספק. Supplier Name: {0}.",
  E0300: "SessionId לא נמצא – כנראה session שפגה.",
  E0500: "שגיאה פנימית חמורה – Internal Service Error.",
  E0501: "Request {0}.{1} לא קיים.",
  E0502: "פעולה מהספק לא מיושמת.",
  E0999: "שגיאה לא ידועה.",
  E1000: "שגיאת ספק.",
  E0400: "פעולה {0} לא ניתנת על קטע במצב {1}.",
  E1100: "בקשה לא חוקית – צ’ק תקינות נכשל. בדוק פרטים נוספים.",
  E2000: "משתמש '{0}' לא מורשה לבצע '{1}'.",
  E2001: "גישה נדחתה למשתמש.",
  E2002: "הגעת למגבלת משאבים (requests per second).",
  E2050: "גישה נדחתה לקטע.",
  E2060: "אישורים לא צוינו.",
  E2061: "אימות אישורים נכשל.",
  E2062: "לא ניתן לספק Credentials ו‑SessionId יחד.",
  E2063: "כרטיס אשראי חשוד (לא עבר בדיקת הונאה).",
  E2300: "קטע לא נמצא.",
  E2301: "חוסר התאמה OrderId.",
  E3000: "תשלום לא מאושר – בעיית כרטיס.",
  E3001: "תשלום לא הושלם.",
  E3002: "חיוב service-fee לא מורשה בחשבון 3D.",
  E3010: "אין שיטות תשלום מוגדרות למשתמש.",
  E3020: "אין הרשאה להזמין מחירים נטו לא ניתנים לביטול.",
  E3030: "אין מספיק obligo להזמנה.",
  E3040: '"{}" כסוג תשלום לא תואם.',
  E3050: "שיטת תשלום לא זמינה – בדוק obligo ונדרש בתשלומים.",
  E3100: "סוג כרטיס לא מותר.",
  E3101: "הקטע כבר סומן כמשולם.",
  E3500: "כלל נסיעה לא נשלחה.",
  E3501: "Route id '{0}' לא נמצא.",
  E3502: "כבר הופקד.",
  E3800: "Car extra עם מזהה '{0}' לא נמצא.",
  E3801: "רכב עם מזהה '{0}' לא נמצא.",
  E3802: "מיקום השכרת רכב לא תקין.",
  E3803: "תנאי השכרת רכב לא זמינים.",
  E3600: "Hotel Id '{0}' לא נמצא בתוצאות החיפוש.",
  E3601: "Package Id '{0}' לא נמצא בתוצאות.",
  I3701: "מידע: לא נמצאו מזהי מלונות ממופים.",
  I3702: "מידע: לא נמצאו מיקומים ממופים.",
  W3703: "אזהרה: חיפוש לפי {0} לא נתמך על ידי הספק.",
  E4300: "שגיאה בשליפת פרטים – כשל בעיבוד תוצאות ספק.",
  E4301: "לא נמצא פריט תואם – יש לשלוח Reprice מחדש.",
  E4302: "כשל בקריאת session – session פג.",
  E4303: "מטבע '{0}' לא נתמך.",
  E1101: "מחיר ההזמנה מחוץ לטווח / ערך ההנחה לא תקין.",
  E4000: "בקשת הזמנה לא תואמת לחבילה – בדוק הקצאת חדרים/נוסעים/ילדים.",
  E4050: "לא ניתן להזמין – הספק החזיר שגיאה.",
  E4051: "ההזמנה לא מותרת בחשבון – בדוק קונטרקט.",
  E4052: "הזמנה כפולה – הספק חסם.",
  E4053: "החבילה לא זמינה כעת.",
  E4060: "לא ניתן להזמין – בעיית כסף/פיקדון.",
  E4070: "הספק דחה את הבקשה.",
  E4100: "ההזמנה לא זמינה יותר – נסה חבילה אחרת.",
  E4101: "לא ניתן להזמין את אותו פריט פעמיים באותה session.",
  E4500: "שגיאת ביטול – מדיניות שינוי/תעריף שונה או תגובת ביטול ריקה.",
  E4501: "לא ניתן לבטל – פנה לצוות טכני.",
  E4502: "ביטול פריט לא נתמך.",
  E6000: "SmartBook נכשל – שגיאה פנימית.",
  E6001: "SmartBook נכשל – שגיאת חיפוש.",
  E6002: "SmartBook נכשל – שגיאה ב-prebook.",
  E6003: "SmartBook נכשל – שגיאה בהזמנה.",
  E6007: "SmartBook: לא צוינו ContractIds למרות שדרוש.",
  E7001: "SmartBook: אין הרשאה להשתמש בתכונה דרך API.",
  E4080: "SmartBook Timeout – לא הושלמה הזמנה.",
};

const PassangerData = ({ dynamicOrder, clientsInfo }) => {
  // Translator
  const { dynamicOrderId } = useParams();
  const loggedUser = JSON.parse(localStorage.getItem("UserInfo"));
  const { isMobile, getAgentCommissionPercent } = useAppContext();
  const {
    currentHotelOrder,
    setCurrentHotelOrder,
    removeCurrentHotelOrder,
    setSaveInfoFunc,
    setSavingInfo,
  } = useOrder();
  const {
    roomsAndPaxInfo,
    setRoomsAndPaxInfo,
    extendedDealApiData,
    ldsSupplement,
    linkedFlightsDealPrice,
  } = useSelectedResult();
  const { t } = useTranslation();
  const {
    searchTab,
    passengerInfo,
    setPassengerInfo,
    availableFlights,
    savedDeal,
    linkedFlights,
    calculateLDSDealFare,
  } = useSearch();
  // Navigator
  const navigate = useNavigate();
  const modalRef = React.createRef();
  const inputRef = React.createRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) // Check if click is not on the model
      ) {
        setIsPopCancelationConditions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef, modalRef]);

  // Constats
  const Rooms =
    currentHotelOrder?.searchPhrase?.rooms || currentHotelOrder.rooms; // Rooms & passengers ( Adults and Kids)

  let RoomData = [];

  const isDynamicPackage = useMemo(() => {
    return savedDeal && searchTab === DYNAMIC_PACKAGES;
  }, [savedDeal, searchTab]);

  if (Rooms) {
    const numberOfRooms = Rooms.length;
    const adultsCountPerRoom = Rooms.map((room) => room.AdultsCount); //Amount of adults minus the two existing ones
    const kidsCountPerRoom = Rooms.map((room) =>
      room.KidsAges ? room.KidsAges.length : 0
    );
    const infantsCountPerRoom = Rooms.map((room) => room.InfantsCount);

    // Create for each room basic stractre with the right amount of adults and kids
    for (let i = 0; i < numberOfRooms; i++) {
      let roomArray = [];

      // Add 2 Main adults (For the first room Create a 1 Contact Person)
      if (i === 0) {
        roomArray.push({
          firstname: null,
          lastname: null,
          cell: null,
          email: null,
          isKid: false,
        });
      } else {
        roomArray.push({ firstname: null, lastname: null, isKid: false });
      }

      // Add additonal adults
      for (let j = 0; j < adultsCountPerRoom[i] - 1; j++) {
        roomArray.push({
          firstname: null,
          lastname: null,
          isKid: false,
        });
      }

      // Add kids
      for (let k = 0; k < kidsCountPerRoom[i]; k++) {
        roomArray.push({
          firstname: null,
          lastname: null,
          isKid: true,
        });
      }

      for (let k = 0; k < infantsCountPerRoom[i]; k++) {
        roomArray.push({
          firstname: null,
          lastname: null,
          isKid: false,
          isInfant: true,
        });
      }

      RoomData.push(roomArray);
    }
  }

  const initialPassangerInfo = RoomData;

  // Create an array of RoomData objects repeated Rooms.length times
  const [specialReq, setSpecialReq] = useState("");
  const [_isConditionsConfirmed, setIsConditionsConfirmed] = useState(false);
  const [isCancelHotel, setIsCancelHotel] = useState(false);
  const [dataCancelHotel, setDataCancelHotel] = useState([]);
  const [dataCancelHotelRemarks, setDataCancelHotelRemarks] = useState([]);
  const [isCancelFlight, setIsCancelFlight] = useState(false);
  const [isPopCancelationConditions, setIsPopCancelationConditions] =
    useState(false);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitLoadingOffer, setSubmitLoadingOffer] = useState(false);
  const [submitLoadingPayment, setSubmitLoadingPayment] = useState(false);

  useEffect(() => {
    if (!passengerInfo) setPassengerInfo(initialPassangerInfo);
  }, [passengerInfo]);

  const isConditionsConfirmed = useMemo(() => {
    let passengerDetailsFilled = false;
    if (isDynamicPackage) {
      passengerDetailsFilled =
        roomsAndPaxInfo.every(
          (room) =>
            room.adults.every((adult) => {
              return (
                adult.firstname && adult.lastname && adult.cell && adult.email
              );
            }) &&
            room.kids.every((kid) => {
              return kid.firstname && kid.lastname;
            }) &&
            room.infants.every((infant) => {
              return infant.firstname && infant.lastname;
            })
        ) || false;
    } else {
      passengerDetailsFilled =
        (!!passengerInfo &&
          (Array.isArray(passengerInfo)
            ? passengerInfo?.every((room) => {
                return (
                  room.every((passenger) => {
                    return passenger.firstname && passenger.lastname;
                  }) || false
                );
              })
            : Object.values(passengerInfo).every((room) => {
                return (
                  room.every((passenger) => {
                    return passenger.firstname && passenger.lastname;
                  }) || false
                );
              }))) ||
        false;
    }
    return passengerDetailsFilled && _isConditionsConfirmed;
  }, [
    isDynamicPackage,
    _isConditionsConfirmed,
    passengerInfo,
    roomsAndPaxInfo,
  ]);

  // Useeffect - get cancalation policys
  useEffect(() => {
    const getCancellationPolicies = async () => {
      const data = {
        session: currentHotelOrder.searchPhrase.session,
        hotelID: parseInt(currentHotelOrder.searchPhrase.hotelID),
        packageID: currentHotelOrder.selectedHotelPackage.packageID,
      };

      const res = await cancellationPolicies(data);
      if (!res.data) {
        return;
      }

      setDataCancelHotel(res.data.policies);

      setDataCancelHotelRemarks(res.data.remarks);
    };

    if (
      currentHotelOrder &&
      currentHotelOrder.searchPhrase &&
      dataCancelHotel &&
      (!dataCancelHotel.length || !dataCancelHotelRemarks.length)
    ) {
      getCancellationPolicies();
    }
  }, [currentHotelOrder]);

  const full_price = useMemo(() => {
    return parseFloat(
      currentHotelOrder?.ourPrice?.priceWithCreditCardFee +
        (isDynamicPackage
          ? linkedFlightsDealPrice +
            Object.values(ldsSupplement).reduce(
              (acc, curr) => acc + (curr.checked ? curr.ourFare : 0),
              0
            )
          : 0)
    );
  }, [
    currentHotelOrder,
    linkedFlightsDealPrice,
    ldsSupplement,
    isDynamicPackage,
  ]);

  const saveInfo = useCallback(
    (isOffer = false) => {
      if (isOffer && !isDynamicPackage) return;
      if (currentHotelOrder) {
        setSavingInfo(true);
        // Set loading on
        if (isOffer) setSubmitLoadingOffer(true);
        else setSubmitLoadingPayment(true);
        // setIsConditionsConfirmed(true);
        disableOtherSubmitBtn("submit2", true);

        // Add passenger data
        currentHotelOrder["passangerData"] = {
          passengerInfo: passengerInfo,
          specialReq: specialReq,
        };

        // Save the updates
        setCurrentHotelOrder(currentHotelOrder);

        const gatherBookingData = () => {
          // Get Data
          // const loggedUser = JSON.parse(localStorage.getItem("UserInfo"));
          const clientData =
            JSON.parse(localStorage.getItem("agent-saved-client-info")) ||
            clientsInfo;

          const { selectedRoom } = currentHotelOrder;

          // Arrange passsangers
          let passangerData = currentHotelOrder.passangerData.passengerInfo;

          let alteredPassangerDataAdults = [];
          let alteredPassangerDataKids = [];

          if (isDynamicPackage) {
            roomsAndPaxInfo.forEach((room) => {
              room.adults.forEach((adult) => {
                let PersonDetails = {
                  PersonDetails: {
                    Name: {
                      GivenName: adult.firstname,
                      NamePrefix: adult.title || "Mr",
                      Surname: adult.lastname,
                    },
                  },
                };
                alteredPassangerDataAdults.push(PersonDetails);
              });
              room.kids.forEach((kid) => {
                let PersonDetails = {
                  PersonDetails: {
                    Name: {
                      GivenName: kid.firstname,
                      NamePrefix: kid.title || "Mr",
                      Surname: kid.lastname,
                    },
                  },
                };
                alteredPassangerDataKids.push(PersonDetails);
              });
              room.infants.forEach((infant) => {
                let PersonDetails = {
                  PersonDetails: {
                    Name: {
                      GivenName: infant.firstname,
                      NamePrefix: infant.title || "Mr",
                      Surname: infant.lastname,
                    },
                  },
                };
                alteredPassangerDataKids.push(PersonDetails);
              });
            });
          } else {
            if (!Array.isArray(passangerData)) {
              passangerData = Object.values(passangerData);
            }
            passangerData.forEach((room) => {
              room.forEach((passenger) => {
                let PersonDetails = {
                  PersonDetails: {
                    Name: {
                      GivenName: passenger.firstname,
                      NamePrefix: passenger.gender || "Mr",
                      Surname: passenger.lastname,
                    },
                  },
                };

                if (!passenger.isKid) {
                  alteredPassangerDataAdults.push(PersonDetails);
                } else {
                  alteredPassangerDataKids.push(PersonDetails);
                }
              });
            });
          }

          const alteredPassangerData = [
            ...alteredPassangerDataAdults,
            ...alteredPassangerDataKids,
          ];

          const currentRoom = currentHotelOrder.selectedHotel.Result.find(
            (r) =>
              r.PackageId === currentHotelOrder.selectedHotelPackage.packageID
          );

          let data = {
            session: currentHotelOrder.searchPhrase.session,
            checkIn: String(currentHotelOrder.searchPhrase.checkIn),
            checkOut: String(currentHotelOrder.searchPhrase.checkOut),
            package: { ...currentRoom, images: selectedRoom?.images },
            passengers: alteredPassangerData,
            commission: currentHotelOrder.ourPrice.hrCommission,
            agentID: loggedUser.id,
            clientID: -1,
            fullname: clientData.fullname,
            cell: clientData.phone,
            email: clientData.email,
            hotel: currentHotelOrder.selectedHotel,
            paid: false,
            remarks: currentHotelOrder.passangerData.specialReq,
            includesTaxes: currentHotelOrder.selectedHotelPackage.includesTaxes,
            handleFee: currentHotelOrder.ourPrice?.handleFeeData?.value || 0,
            handleFeeOption:
              currentHotelOrder.ourPrice?.handleFeeData?.type || "+",
            totalPrice:
              currentHotelOrder.ourPrice.priceWithCreditCardFee.toFixed(2),
            cardFee: currentHotelOrder.ourPrice.creditCardFee.toFixed(2),
            cards: [],
          };
          return data;
        };

        const setCurrentOrderId = (orderId) => {
          localStorage.removeItem("agent-saved-client-info");
          navigate("/p/dashboard/payment/" + orderId);
        };

        const setCurrentDynamicOrderOfferId = (orderId) => {
          localStorage.removeItem("agent-saved-client-info");
          navigate("/dynamic/offer/" + orderId);
        };

        const setCurrentDynamicOrderId = (orderId) => {
          localStorage.removeItem("agent-saved-client-info");
          navigate("/dynamic/profile/" + orderId);
        };

        const bookInfo = gatherBookingData();

        // New order payment
        // console.dir(bookInfo);
        if (isDynamicPackage) {
          const user = getUserDetails();
          const { id } = user;
          const { depDate, retDate } = get_depret_from_result(savedDeal);
          const ourPrice = calculateLDSDealFare(savedDeal);

          const flightsInfo = {
            agent_id: id,
            later: "false",
            commission: ourPrice.agentCommission,
            handling_fee: 0,
            currency: "ILS",
            deal_id: savedDeal.dealId,
            deal_type: "Flights",
            supplierId: savedDeal.supplierId,
            passengers_info: roomsAndPaxInfo,
            ret_date: parseToLdsDate(retDate),
            dep_date: parseToLdsDate(depDate),
            supplement: ldsSupplement,
            ourPrice: ourPrice,
            linkedFlights: linkedFlights,
            extended: extendedDealApiData,
          };

          saveDynamicPackage({
            dynamicId: dynamicOrderId,
            clientsInfo: clientsInfo,
            hotelOffer: currentHotelOrder,
            hotel: bookInfo,
            flights: flightsInfo,
            agentID: id,
            total_price: full_price,
            currency: "ILS",
            check_in: flightsInfo.dep_date,
            check_out: flightsInfo.ret_date,
          })
            .then((res) => {
              if (res.data.status !== "ok") {
                message.error("שגיאה בהזמנת המלון");
                setSubmitLoadingOffer(false);
                setSavingInfo(false);
                return;
              }
              const dynamic_package_id = res.data.id;
              if (dynamic_package_id) {
                if (isOffer) setCurrentDynamicOrderOfferId(dynamic_package_id);
                else setCurrentDynamicOrderId(dynamic_package_id);
              }
              message.success("הזמנה נשמרה במערכת, ניתן להמשיך לתשלום");
              setSubmitLoadingOffer(false);
              setSavingInfo(false);
            })
            .catch((err) => {
              message.error("שגיאה בהזמנת המלון");
              setSubmitLoadingOffer(false);
              setSavingInfo(false);
            });
        } else
          newHotelOrder(bookInfo)
            .then((res) => {
              const orderId = res.data.id;
              if (orderId) setCurrentOrderId(orderId);
              else if (res.data.status === "fail" && res.data.code) {
                const code = res.data.code;
                if (errorCodes[code]) {
                  notification.error({
                    message: "שגיאה בהזמנת המלון",
                    description: errorCodes[code],
                    placement: "bottomRight",
                    duration: 5,
                  });
                } else {
                  notification.error({
                    message: "שגיאה בהזמנת המלון",
                    description: "שגיאה לא ידועה",
                    placement: "bottomRight",
                    duration: 5,
                  });
                }
              }
              setSubmitLoading(false);
              setSavingInfo(false);
              // Set loading on
              setSubmitLoadingPayment(false);
              // setIsConditionsConfirmed(false);
              disableOtherSubmitBtn("submit2", false);
            })
            .catch((err) => {
              message.error("שגיאה בהזמנת המלון");
              // Set loading on
              setSubmitLoadingPayment(false);
              // setIsConditionsConfirmed(false);
              disableOtherSubmitBtn("submit2", false);
              setSavingInfo(false);
            });
      } else {
        CustomAlertAgent(
          t("warnings.somthingwentwrong"),
          t("warnings.tryagain")
        );
      }
    },
    [
      ldsSupplement,
      currentHotelOrder,
      passengerInfo,
      specialReq,
      roomsAndPaxInfo,
      isDynamicPackage,
      clientsInfo,
      linkedFlightsDealPrice,
      savedDeal,
      calculateLDSDealFare,
      getUserDetails,
      navigate,
      setCurrentHotelOrder,
      setSavingInfo,
      setSubmitLoadingOffer,
      setSubmitLoadingPayment,
      setSaveInfoFunc,
      t,
      extendedDealApiData,
      full_price,
      newHotelOrder,
      saveDynamicPackage,
      removeCurrentHotelOrder,
      notification,
      message,
      CustomAlertAgent,
      get_depret_from_result,
      parseToLdsDate,
      linkedFlights,
    ]
  );

  useEffect(() => {
    // Set saveInfo function
    setSaveInfoFunc(() => saveInfo);
  }, [saveInfo]);

  // --- Functions
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitLoading || submitLoadingPayment) {
      return;
    }

    if (!isConditionsConfirmed) {
      CustomAlertAgent(t("warnings.approveconditions"), t("warnings.goback"));
      return;
    }
    saveInfo();
  };

  // Triggers
  const showMoreHotelCancelation = () => {
    setIsCancelHotel(!isCancelHotel);
  };

  const showMoreFlightCancelation = () => {
    setIsCancelFlight(!isCancelFlight);
  };

  const openCancelationConditions = () => {
    setIsPopCancelationConditions(!isPopCancelationConditions);
  };

  // For pay later check if all inputs were answered
  const checkRequiredInputs = () => {
    // Check if all required inputs are filled
    const requiredInputs = document.querySelectorAll(
      ".passangerData-component input"
    );

    for (const input of requiredInputs) {
      // Check if it's a checkbox and is checked, or if it's a text input and has a value
      if (input.type === "checkbox" && !input.checked) {
        CustomAlertAgent(t("warnings.fillallinputs"), t("warnings.goback"));
        return false;
      } else if (input.type === "text" && input.value.trim() === "") {
        CustomAlertAgent(t("warnings.fillallinputs"), t("warnings.goback"));
        return false;
      }
    }
    return true;
  };

  // For new order
  const bookWithOutPay = async (e) => {
    e.preventDefault();

    if (submitLoading || submitLoadingPayment) {
      return;
    }

    const gatherPayMentData = (paid) => {
      // Get Data
      const loggedUser = JSON.parse(localStorage.getItem("UserInfo"));
      const clientData = JSON.parse(
        localStorage.getItem("agent-saved-client-info")
      );
      const { selectedRoom } = currentHotelOrder;

      // Arrange passsangers
      let passangerData = passengerInfo;

      let alteredPassangerDataAdults = [];
      let alteredPassangerDataKids = [];

      if (!Array.isArray(passangerData)) {
        passangerData = Object.values(passangerData);
      }

      passangerData.forEach((room) => {
        room.forEach((passenger) => {
          let PersonDetails = {
            PersonDetails: {
              Name: {
                GivenName: passenger.firstname,
                NamePrefix: passenger.gender || "Mr",
                Surname: passenger.lastname,
              },
            },
            Email: passenger.email
              ? {
                  Value: passenger.email,
                }
              : undefined,
            Telephone: passenger.cell
              ? {
                  PhoneNumber: passenger.cell,
                }
              : undefined,
          };

          if (!passenger.isKid) {
            alteredPassangerDataAdults.push(PersonDetails);
          } else {
            alteredPassangerDataKids.push(PersonDetails);
          }
        });
      });

      const alteredPassangerData = [
        ...alteredPassangerDataAdults,
        ...alteredPassangerDataKids,
      ];

      const currentRoom = currentHotelOrder.selectedHotel.Result.find(
        (r) => r.PackageId === currentHotelOrder.selectedHotelPackage.packageID
      );

      let data = {
        session: currentHotelOrder.searchPhrase.session,
        checkIn: String(currentHotelOrder.searchPhrase.checkIn),
        checkOut: String(currentHotelOrder.searchPhrase.checkOut),
        package: { ...currentRoom, images: selectedRoom?.images },
        passengers: alteredPassangerData,
        commission: getAgentCommissionPercent(),
        agentID: loggedUser.id, // ?
        clientID: -1, // ?
        fullname: clientData.fullname,
        cell: clientData.phone,
        email: clientData.email,
        hotel: currentHotelOrder.selectedHotel,
        paid: paid,
        remarks: specialReq,
        includesTaxes: currentHotelOrder.selectedHotelPackage.includesTaxes,
        handleFee: currentHotelOrder.ourPrice?.handleFeeData?.value || 0,
        handleFeeOption: currentHotelOrder.ourPrice?.handleFeeData?.type || "+",
        totalPrice: currentHotelOrder.ourPrice.priceWithCreditCardFee,
        cardFee: 0, //cardFee,
        cards: [],
        payments: [],
        ourPrice: currentHotelOrder.ourPrice,
      };

      return data;
    };

    // Check required inputs
    if (!checkRequiredInputs()) {
      return;
    }

    // Set loading on
    setSubmitLoading(true);
    disableOtherSubmitBtn("submit1", true);

    const data = gatherPayMentData(false); // false stands for pay later

    // Book hotel
    const res = await bookHotel(data);

    if (res.data && res.data.status === "ok") {
      // Reset Order
      removeCurrentHotelOrder();
      localStorage.removeItem("agent-saved-client-info");

      navigate("/p/dashboard/success/" + res.data.id);
    } else {
      const code = res.data.code;
      if (errorCodes[code]) {
        notification.error({
          message: "שגיאה בהזמנת המלון",
          description: errorCodes[code],
          placement: "bottomRight",
          duration: 5,
        });
      } else {
        notification.error({
          message: "שגיאה בהזמנת המלון",
          description: "שגיאה לא ידועה",
          placement: "bottomRight",
          duration: 5,
        });
      }
    }

    // Set loading off
    setSubmitLoading(false);
    disableOtherSubmitBtn("submit1", false);
  };

  const disableOtherSubmitBtn = (idOfButton, state) => {
    const button = document.getElementById(idOfButton);

    if (button) {
      button.disabled = state;
    }
  };

  function handlePassengerInfoChange(roomIndex, newPassengerInfo) {
    let tempPassengerInfo = JSON.parse(JSON.stringify(roomsAndPaxInfo));
    tempPassengerInfo[roomIndex] = newPassengerInfo;
    setRoomsAndPaxInfo(tempPassengerInfo);
  }

  return (
    <form onSubmit={handleSubmit} className="passangerData-component">
      {/* Notification - For hotel Choosing */}
      {loggedUser ? (
        <NotificationPass
          title={t("completepassengers.greatchoice")}
          subtitle={t("completepassengers.greatchoicetext")}
        />
      ) : (
        <>
          {dynamicOrder && dynamicOrder.agent ? (
            <>
              {dynamicOrder.agent.companylogobase65 ? (
                <div className="company-logo-container">
                  <img
                    src={dynamicOrder.agent.companylogobase65}
                    alt={dynamicOrder.agent.companyname}
                  />
                </div>
              ) : null}
              <Card
                key="agent-info"
                title={"פרטי סוכן"}
                styles={{
                  title: {
                    whiteSpace: "unset",
                    textOverflow: "unset",
                  },
                  header: {
                    minHeight: "unset",
                    padding: "10px",
                  },
                  body: {
                    padding: "10px",
                  },
                }}
              >
                <span>
                  <strong>שם הסוכנות:</strong> {dynamicOrder.agent.companyname}
                </span>
                <br />
                <span>
                  <strong>שם פרטי:</strong> {dynamicOrder.agent.firstname}
                </span>
                <br />
                <span>
                  <strong>שם משפחה:</strong> {dynamicOrder.agent.lastname}
                </span>
                <br />
                <span>
                  <strong>אימייל:</strong> {dynamicOrder.agent.email}
                </span>
                <br />
                <span>
                  <strong>טלפון:</strong> {dynamicOrder.agent.cell}
                </span>
              </Card>
            </>
          ) : null}
          <Card
            key="offer-info"
            title={
              "הצעה עבור מלון וטיסות ל" +
              currentHotelOrder?.selectedHotel?.HotelName +
              " בתאריכים " +
              currentHotelOrder?.searchPhrase?.checkIn +
              " - " +
              currentHotelOrder?.searchPhrase?.checkOut
            }
            styles={{
              title: {
                whiteSpace: "unset",
                textOverflow: "unset",
              },
              header: {
                minHeight: "unset",
                padding: "10px",
              },
              body: {
                padding: "10px",
              },
            }}
          >
            {t("ordersummery.offerintroduction")}
            <br />
            <div
              className="small"
              style={{
                fontSize: "0.8rem",
                fontWeight: "bold",
              }}
            >
              {t("ordersummery.pricemightchange")}
            </div>
          </Card>
        </>
      )}

      {(!isMobile || !loggedUser) && availableFlights ? (
        <FlightSelection
          isCard
          isSelectable={loggedUser ? true : false}
          isCompact
          title={<span>✈️ {t("ordersummery.flights")}</span>}
        />
      ) : null}

      {/* Room Displayer */}
      {!passengerInfo ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      ) : loggedUser ? (
        <div className="passangerData-room-pass-info-wrapper">
          {!isDynamicPackage
            ? Rooms.map((room, index) => (
                <RoomPassInfo
                  key={index}
                  roomInfo={room}
                  roomNumber={index}
                  roomName={
                    currentHotelOrder.selectedHotelPackage.roomNames[index]
                  }
                />
              ))
            : roomsAndPaxInfo?.map((passengerInfo, roomIndex) => (
                <PassengerData
                  key={roomIndex}
                  roomIndex={roomIndex}
                  passengerInfo={passengerInfo}
                  setPassengerInfo={(newPassengerInfo) =>
                    handlePassengerInfoChange(roomIndex, newPassengerInfo)
                  }
                  roomName={`(${passengerInfo?.room?.roomSet}) ${passengerInfo?.room?.roomType}`}
                  returnDate={
                    currentHotelOrder.searchPhrase?.checkOut ||
                    currentHotelOrder.checkout
                  }
                  isTour={false}
                  allDisabled={loggedUser ? false : true}
                />
              ))}
        </div>
      ) : null}

      {/* Supplements */}
      {isDynamicPackage && loggedUser ? (
        <div className="passangerData-supplements-wrapper">
          <Supplement disabled={false} />
        </div>
      ) : null}

      {loggedUser ? (
        <>
          {/* Special Requests */}
          <div className="passangerData-special-requests-wrapper">
            <label className="passangerData-special-requests-title">
              {t("completepassengers.specialrequests")}
            </label>

            <textarea
              onChange={(e) => {
                setSpecialReq(e.target.value);
              }}
              className="passangerData-special-requests-textarea"
              rows="4"
              cols="100%"
              placeholder={t("completepassengers.specialrequeststext")}
            ></textarea>
          </div>

          {/* Cancelation Policy - Hotel */}
          <div className={`passangerData-cancelation-policy-wrapper`}>
            <label className="passangerData-cancelation-policy-title">
              {t("completepassengers.policycanclationhotel")}
            </label>

            <label className="passangerData-cancelation-policy-sub-title">
              {currentHotelOrder.selectedHotel?.HotelName ||
                currentHotelOrder.HotelName}
            </label>

            <div
              className={`passangerData-cancelation-policy-cancel-wrapper  ${
                isCancelHotel
                  ? "passangerData-cancelation-policy-wrapper-wide"
                  : ""
              }`}
            >
              <div className="passangerData-cancelation-policy-cancel-heading-wrapper">
                {currentHotelOrder.selectedHotelPackage?.refundability ||
                currentHotelOrder.refundability ? (
                  <label className="passangerData-cancelation-policy-cancel-title">
                    {t("completepassengers.freecancelation")}{" "}
                    {currentHotelOrder.selectedHotelPackage?.refundableUntil ||
                      currentHotelOrder.refundableUntil}
                  </label>
                ) : (
                  <>
                    <label className="passangerData-cancelation-policy-cancel-title-not-free">
                      {t("completepassengers.nofreecancelation")}
                      <span style={{ marginRight: 15 }}>-</span>
                      <span style={{ marginRight: 15 }}>
                        {/* {dataCancelHotel
                          ? convertPrice(
                              dataCancelHotel[0]?.fee + linkedFlightsDealPrice
                            )
                          : null} */}
                        {convertPrice(full_price)}
                      </span>
                    </label>
                  </>
                )}

                {!isCancelHotel && (
                  <div
                    onClick={showMoreHotelCancelation}
                    className="passangerData-showmore-wrapper"
                  >
                    <BiChevronDown className="assangerData-showmore-arrow"></BiChevronDown>
                    <label className="passangerData-cancelation-policy-cancel-more">
                      {t("completepassengers.showmore")}
                    </label>
                  </div>
                )}
              </div>

              {dataCancelHotelRemarks && isCancelHotel && (
                <div className="passangerData-cancelation-entrys-button-wrapper">
                  <div className="passangerData-cancelation-entrys-remark-wrapper">
                    <div
                      className="passangerData-cancelation-policy-remarks"
                      dangerouslySetInnerHTML={{
                        __html: dataCancelHotelRemarks,
                      }}
                    />

                    {dataCancelHotel.length > 0 ? (
                      <div className="passangerData-cancelation-entrys">
                        {dataCancelHotel.map((cancelRowData, index) => (
                          <div key={index}>
                            <label className="passangerData-cancelation-entry">
                              {t("completepassengers.startsat")}
                              {cancelRowData.from}{" "}
                              {t("completepassengers.feesare")}{" "}
                              {
                                <label id="price-fee">
                                  {convertPrice(full_price)}
                                </label>
                              }
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="passangerData-cancelation-empty">
                        No Canclation Policys Available
                      </div>
                    )}
                  </div>

                  <div
                    onClick={showMoreHotelCancelation}
                    className="passangerData-showmore-wrapper"
                  >
                    <BiChevronUp className="assangerData-showmore-arrow"></BiChevronUp>
                    <label className="passangerData-cancelation-policy-cancel-more">
                      {t("completepassengers.showless")}
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : null}

      {/* Cancelation Policy - Flight */}
      {/* <div className="passangerData-cancelation-policy-wrapper">
        <label className="passangerData-cancelation-policy-title">
          {t("completepassengers.policycanclationflight")}
        </label>

        <label className="passangerData-cancelation-policy-sub-title">
          flight name...
        </label>

        <div
          className={`passangerData-cancelation-policy-cancel-wrapper  ${
            isCancelFlight
              ? "passangerData-cancelation-policy-wrapper-wide"
              : ""
          }`}
        >
          <div className="passangerData-cancelation-policy-cancel-heading-wrapper">
            <label className="passangerData-cancelation-policy-cancel-title">
              {t("completepassengers.freecancelation")}
            </label>

            {!isCancelFlight && (
              <div
                onClick={showMoreFlightCancelation}
                className="passangerData-showmore-wrapper"
              >
                <BiChevronDown className="assangerData-showmore-arrow"></BiChevronDown>
                <label className="passangerData-cancelation-policy-cancel-more">
                  {t("completepassengers.showmore")}
                </label>
              </div>
            )}
          </div>

          {isCancelFlight && (
            <div className="passangerData-cancelation-entrys-button-wrapper">
              {dataCancelFlight.length > 0 ? (
                <div className="passangerData-cancelation-entrys">
                  {dataCancelFlight.map((cancelRowData, index) => (
                    <div key={index}>
                      <label className="passangerData-cancelation-entry">
                        {t("completepassengers.startsat")} {cancelRowData.from}{" "}
                        {t("completepassengers.startsat")} {cancelRowData.to}{" "}
                        {t("completepassengers.feesare")}{" "}
                        {
                          <label id="price-fee">
                            {convertPrice(cancelRowData.fee)}
                          </label>
                        }
                      </label>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="passangerData-cancelation-empty">
                  No Canclation Policys Available
                </div>
              )}

              <div
                onClick={showMoreFlightCancelation}
                className="passangerData-showmore-wrapper"
              >
                <BiChevronUp className="assangerData-showmore-arrow"></BiChevronUp>
                <label className="passangerData-cancelation-policy-cancel-more">
                  {t("completepassengers.showless")}
                </label>
              </div>
            </div>
          )}
        </div>
      </div> */}

      {/* Payment */}
      {loggedUser ? (
        <div className="passangerData-checkout-wrapper">
          <div className="passangerData-checkout-checkbox-wrapper">
            <input
              type="checkbox"
              className="passangerData-checkout-checkbox"
              required
              onChange={(e) => setIsConditionsConfirmed(e.target.checked)}
            ></input>
            <span className="passangerData-checkout-checkbox-text-black">
              {`${t("completepassengers.approve")}`}
            </span>
            <span
              className="passangerData-checkout-checkbox-text"
              onClick={openCancelationConditions}
            >
              {t("completepassengers.confirmconditions")}
            </span>

            {isPopCancelationConditions ? (
              <div className="passangerData-popup-wrapper">
                <div
                  ref={modalRef}
                  className="passangerData-popup-frame tw-pt-4"
                >
                  <TermsAndConditions />
                  <div className="passangerData-popup-agree-btn-wrapper">
                    <button
                      type="button"
                      className="passangerData-popup-agree-btn"
                      onClick={openCancelationConditions}
                    >
                      {t("completepassengers.close")}
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          <div className="passangerData-checkout-button-wrapper">
            <div className="passangerData-submit-button-wrapper">
              {!submitLoadingPayment ? (
                <button
                  type="submit"
                  id="submit1"
                  className={
                    !isConditionsConfirmed
                      ? "button-disabled"
                      : "passangerData-checkout-button"
                  }
                  disabled={!isConditionsConfirmed}
                >
                  {t("completepassengers.pay")}
                </button>
              ) : (
                <CustomLoading
                  classLoading={""}
                  labelLoading={t("completepassengers.pay")}
                />
              )}
            </div>

            <div className="passangerData-submit-button-wrapper">
              {(currentHotelOrder.selectedHotelPackage?.refundability ||
                currentHotelOrder.refundability) &&
                searchTab !== DYNAMIC_PACKAGES &&
                (!submitLoading ? (
                  <button
                    type="button"
                    id="submit2"
                    className={
                      !isConditionsConfirmed
                        ? "button-disabled"
                        : "passangerData-submit-button-pay-later"
                    }
                    onClick={bookWithOutPay}
                    disabled={!isConditionsConfirmed}
                  >
                    {t("completepassengers.paylater")}
                  </button>
                ) : (
                  <CustomLoading
                    classLoading={""}
                    labelLoading={t("completepassengers.paylater")}
                  />
                ))}
            </div>
          </div>
        </div>
      ) : null}
    </form>
  );
};

export default PassangerData;

//{
//     "adults": [
//         {
//             "firstname": "sfdsdf",
//             "lastname": null,
//             "cell": "",
//             "email": ""
//         },
//         {
//             "firstname": "sfdsdf",
//             "lastname": null,
//             "cell": "",
//             "email": ""
//         }
//     ],
//     "kids": []
// }
